var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowupcirclefill({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -70.4590 92.5300 70.4590",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.2402 4.15039C68.0176 4.15039 85.6934-13.5254 85.6934-35.2539C85.6934-56.9824 68.0176-74.6582 46.2402-74.6582C24.5117-74.6582 6.83594-56.9824 6.83594-35.2539C6.83594-13.5254 24.5117 4.15039 46.2402 4.15039Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2891-15.0879C48.291-15.0879 49.9023-16.6504 49.9023-18.6035L49.9023-39.502L49.6094-48.2422C49.5605-50.3418 47.9004-51.416 46.2891-51.416C44.7266-51.416 43.1152-50.3418 43.0176-48.2422L42.6758-39.502L42.6758-18.6035C42.6758-16.6504 44.3359-15.0879 46.2891-15.0879ZM46.2891-55.4199C45.3613-55.4199 44.6289-55.127 43.7012-54.1992L30.6641-41.7969C29.9805-41.1133 29.5898-40.3809 29.5898-39.4043C29.5898-37.5488 30.957-36.2305 32.8613-36.2305C33.7402-36.2305 34.7168-36.5723 35.3516-37.3047L40.918-43.3594L46.2891-49.1211L46.2891-49.1211L51.6602-43.3594L57.2754-37.3047C57.8613-36.5723 58.8379-36.2305 59.7168-36.2305C61.5723-36.2305 62.9883-37.5488 62.9883-39.4043C62.9883-40.3809 62.6465-41.1133 61.9141-41.7969L48.9258-54.1992C47.998-55.127 47.2656-55.4199 46.2891-55.4199Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowupcirclefill);
export default __webpack_public_path__ + "static/media/arrow.up.circle.fill.1a413f8caad109afe0430c0d1b6683e4.svg";
export { ForwardRef as ReactComponent };